import { useEffect, useRef } from "react";

const Modal = ({ isOpen, onClose, title, children }) => {
    const modalContentRef = useRef(null);
  
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (modalContentRef.current && !modalContentRef.current.contains(event.target)) {
          onClose();
        }
      };
  
      if (isOpen) {
        document.addEventListener('mousedown', handleClickOutside);
      }
  
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [isOpen, onClose]);
  
    if (!isOpen) return null;
  
    return (
      <div className="fixed inset-0 bg-black bg-opacity-70 backdrop-blur-sm flex items-center justify-center z-50">
        <div
          ref={modalContentRef}
          className="
            bg-gray-900 bg-opacity-95 rounded-2xl shadow-2xl shadow-purple-800/60
            p-6 md:p-8 w-11/12 max-w-lg md:max-w-[70vw] lg:max-w-[60vw] xl:max-w-[50vw]
            transform transition-all duration-300 scale-100 opacity-100
            border-2 border-purple-600
          "
          style={{ fontFamily: 'Inter, sans-serif' }}
        >
          <div className="flex justify-between items-center mb-5 border-b border-purple-700 pb-3">
            <h2 className="text-2xl md:text-3xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-blue-400 drop-shadow-lg">
              {title}
            </h2>
            <button
              onClick={onClose}
              className="
                text-purple-300 hover:text-pink-400 text-3xl leading-none font-semibold
                transition-colors duration-200
                p-1 rounded-full hover:bg-purple-700
              "
            >
              &times;
            </button>
          </div>
          <div className="text-gray-200 text-sm md:text-base leading-relaxed overflow-y-auto max-h-[80vh] pr-2 custom-scrollbar">
            {children}
          </div>
        </div>
      </div>
    );
  };
  export default Modal;